import { isClient, isTutor } from './user';
export const getPersonFromParticipants = (self, participants) => {
    const callerIsTutor = isTutor(self.type);
    const filteredParticipants = participants.filter((v) => callerIsTutor ? isClient(v.type) : isTutor(v.type));
    return filteredParticipants[0];
};
//# sourceMappingURL=conversation.js.map